<template>
  <q-card>
    <q-card-section class="row justify-center q-mx-lg">
      <span class="text-subtitle1 text-weight-medium text-center">{{$gettext('REPORT_SELECTION')}}</span>
    </q-card-section>
    <q-card-section v-if="measurementReportParams && measurementReportParams.contractBillingType === 20560005" class="row justify-center q-mx-lg">
      <div class="column q-gutter-sm">
        <span class="text-subtitle2 text-weight-medium">{{
          $gettext("REPORT_TYPE")
        }}</span>
        <div class="row q-gutter-md">
          <q-radio v-model="measurementReportType" :val="$gettext('ANALYTICAL')" :label="$gettext('ANALYTICAL')" />
          <q-radio v-model="measurementReportType" :val="$gettext('SYNTHETIC')" :label="$gettext('SYNTHETIC')" />
        </div>
      </div>
    </q-card-section>

    <q-card-section class="row justify-center q-mx-lg">
      <q-radio v-model="measurementReportFormat" val="pdf" label="PDF" />
      <q-radio v-model="measurementReportFormat" val="xls" label="Excel" />
    </q-card-section>
    <q-card-actions class="justify-center q-pa-md q-my-sm">
      <q-btn :label="$gettext('CANCEL')" color="grey-7" v-close-popup class="q-px-lg" />
      <q-btn :label="$gettext('GENERATE')" color="info" v-close-popup @click="emitGenerateReport" class="q-px-lg" />
    </q-card-actions>
  </q-card>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'

const CrudLayout = JtCrud.CrudLayout

@Component({
  name: 'billingOrderReportSelection',
  components: { CrudLayout },
  props: {
    measurementReportParams: {
      type: Object,
      required: false,
      default: null
    },
    measurementReportType: {
      type: String,
      required: false,
      default: 'ANALYTICAL'
    },
    measurementReportFormat: {
      type: String,
      required: false,
      default: 'pdf'
    }
  }
})
export default class billingOrderReportSelection extends Vue {
  get typeModel () {
    return this.measurementReportType
  }

  set typeModel (value) {
    this.$emit('update:measurementReportType', value)
  }

  get formatModel () {
    return this.measurementReportFormat
  }

  set formatModel (value) {
    this.$emit('update:measurementReportFormat', value)
  }

  emitGenerateReport () {
    this.$emit('generate-report', {
      measurementReportType: this.measurementReportType,
      measurementReportFormat: this.measurementReportFormat
    })
  }
}
</script>

<style lang='stylus' scoped>

</style>
